import type { CavaloReal } from './tipos.js';

/**
 * Fora da build da apresentacao, `@equiview/cavalo-real` aponta para ca (ver
 * vite.config.ts): nenhum cavalo real, e nenhum arquivo dele vai para a build.
 */
export const CAVALO_REAL: CavaloReal | null = null;
